module.exports = __webpack_public_path__ + "static/media/texture (20).b5f399e7.jpg";